var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-tag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.53108 9.49407C8.53108 8.68331 9.18639 8.03105 9.9941 8.03105C10.8049 8.03105 11.4571 8.68331 11.4571 9.49407C11.4571 10.3048 10.8049 10.9571 9.9941 10.9571C9.18639 10.9571 8.53108 10.3048 8.53108 9.49407ZM3.16667 5.59267C3.16667 3.97664 4.47667 2.66663 6.09271 2.66663H15.2061C16.2424 2.66663 17.23 3.07749 17.9615 3.80961L28.6903 14.5354C30.2143 16.0594 30.2143 18.5343 28.6903 20.0583L20.5584 28.1903C19.0344 29.7143 16.5594 29.7143 15.0354 28.1903L4.30964 17.4615C3.57771 16.7299 3.16666 15.7424 3.16666 14.7061L3.16667 5.59267ZM5.68854 16.0838L16.4192 26.8126C17.1812 27.5746 18.4126 27.5746 19.1746 26.8126L27.3127 18.6746C28.0746 17.9126 28.0746 16.6812 27.3127 15.9192L16.5838 5.18851C16.2181 4.82276 15.6694 4.61733 15.2061 4.61733H6.09271C5.55382 4.61733 5.11736 5.05379 5.11736 5.59267V14.7061C5.11736 15.1694 5.32279 15.718 5.68854 16.0838Z",
    fill: "#001D3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTag);
export default __webpack_public_path__ + "static/media/icon-tag.3705c345848a3b1181996792bb4c1b16.svg";
export { ForwardRef as ReactComponent };